const Form078EN = {
    stepName: {
        information: "Basic Information",
        partA: "Part A\nParticulars of the serving contract staff and supply staff",
        partB: "Part B\nAmount claimed and supplementary information",
        partC: "Part C\nCertification",
        confirm: "Confirmation",
    },
    notes: {
        notesTitle: "Statement",
        importantNote1:
            "[i.e. PLEASE READ THE FOLLOWING TERMS AND CONDITIONS BEFORE USING THIS WEBSITE. BY USING THIS WEBSITE YOU AGREE TO ABIDE BY THE TERMS AND CONDITIONS SET OUT BELOW\nplease submit either e-form or paper, if duplicate application has been submitted, the process would be decelerated.",
        importantNote2:
            "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.]",
        importantNote3:
            "This form is applicable for employment of supply staff to cover the 14-week paid maternity leave of contract staff remunerated under the EDB's cash grants.",
        note1: "If the serving contract staff is <u>not entitled</u> to <u>paid</u> maternity leave under the Employment Ordinance (Cap. 57), even if the school has employed supply staff to take up the duties of the contract staff, it is <u>not eligible</u> to receive the Additional Substitute Staff Grant from the EDB.",
        note2: "Additional salary expenditure refers to the salary expenditure incurred by the employment of supply staff to cover <u>the additional four-week paid statutory maternity leave</u> taken by the serving contract staff (i.e. up to 28 days).",
        note3: "Reimbursement is <u>capped</u> with reference to the salary of the serving contract staff that would otherwise receive for normal working days (not on the basis of the salary receivable during the maternity leave). If the serving contract staff works on part-time basis, the monthly salary that <u>reflects</u> the part-time duties should be filled in. If the additional four-week maternity leave of the serving contract staff straddles across two calendar months and the monthly salary of these two calendar months varies, the respective salary of these two calendar months should be stated separately.",
        note3a: "Reimbursement is <u>capped</u> with reference to the salary of the serving contract staff that would otherwise receive for normal working days (not on the basis of the salary receivable during the maternity leave). If the serving contract staff works on part-time basis, the monthly salary that <u>reflects</u> the part-time duties should be filled in. If the additional four-week maternity leave of the serving contract staff straddles across two calendar months and the monthly salary of these two calendar months varies, the respective salary of these two calendar months should be stated separately. In addition, schools should state the <u>average daily wage</u> that the serving contract staff would otherwise receive during the additional four-week maternity leave (calculated by monthly salary of the serving contract staff x 12 months/365 days).",
        note4: "The salary of the serving contract staff should be provided by the <u>EDB's cash grants</u>.",
        note5: "During the additional four-week maternity leave taken by the serving contract staff, if more than one person is employed as supply staff, the school should provide the names and employment details of these persons <u>separately</u>.",
        note6: "The percentage of full-time job taken up by supply staff <u>should not exceed</u> the percentage of full-time job remunerated under the EDB's cash grants that the serving contract staff would otherwise take up during the additional four-week paid maternity leave (i.e. 28 days) [i.e. the percentage of full-time job stated in field ({{field}})].",
        note7: "The monthly salary of the supply staff <u>should not exceed</u> the monthly salary of the serving contract staff [i.e. the monthly salary stated in field (b)]. If the additional four-week maternity leave of the serving contract staff straddles across two calendar months and the monthly salary of these two calendar months varies, the respective salary receivable by the supply staff <u>should not exceed</u> the corresponding salary that the serving contract staff would otherwise receive during these two calendar months. If the supply staff works on part-time basis, the monthly salary that <u>reflects</u> the part-time duties should be filled in and the percentage of full-time job taken should be stated in field (c).",
        note7a: "The daily rate of the supply staff <u>should not exceed</u> the average daily wage of the serving contract staff [i.e. the converted average daily wage in field(h)]. If the additional four-week maternity leave of the serving contract staff straddles across two calendar months and the monthly salary and converted average daily wage of these two calendar months varies, the daily rate receivable by the supply staff <u>should not exceed</u> the <u>corresponding</u> average daily wage that the serving contract staff would otherwise earn during these two calendar months. If the supply staff works on part-time basis, the daily rate that <u>reflects</u> the part-time duties should be filled in and the percentage of full-time job taken should be stated in field(i).",
        note8: "The number of calendar days covered by substitution refers to the calendar days from the start date to the end date of the period (both dates inclusive) and the total in this field <u>should not exceed 28 days</u>. If the supply staff has taken no-pay leave during the employment period, <u>the number of days covered by such no-pay leave should be deducted</u> from the number of calendar days working as supply staff and details should be provided under (i) of Part B by the school.",
        note8a: "The number of actual working days <u>should exclude</u> public holidays, discretionary holidays and any days on which staff are not required to perform duties. The total number of actual working days <u>should not exceed 28 days</u>.",
        note9: "Salary amount should be determined on a pro rata basis according to the number of calendar days working as supply staff [average daily wage of supply staff (monthly salary of supply staff x 12 months / 365 days) x number of days working as supply staff].",
        note9a: "Salary amount should be calculated according to the daily rate of the supply staff x number of actual working days of the supply staff.",
        note10: `The Mandatory Provident Fund (MPF) subsidy is either 5% of the relevant income or the amount subject to maximum income level as calculated <u>on a pro rata basis according to 28 days</u> [$1,381 = $1,500 per month (current maximum level of monthly contribution) x 12 months / 365 days x 28 days].  Schools not required to contribute to MPF for their supply staff should fill in "0" in this field.`,
        termsTips1: "Applicants should read carefully and agree",
        termsTips2: "Notes on private data",
        agreeTips:
            "I have read, understood and agreed to the above terms and conditions.",
    },
    button: {
        addSupplyStaff: "ADD SUPPLY STAFF",
        removeSupplyStaff: "REMOVE SUPPLY STAFF",
    },
    serial: {
        tips: {
            num1: "(ⅰ)",
            num2: "(ⅱ)",
            num3: "(ⅲ)",
            num4: "(ⅳ)",
            num5: "(ⅴ)",
            num6: "(ⅵ)",
            num7: "(ⅶ)",
            num8: "(ⅷ)",
        },
    },
    label: {
        basicOption: {
            note: "Note",
            contactPerson: "School's Contact Person",
        },
        informationTitle: "School Information",
        formType: "New/Revised Form",
        schoolName: "Name of School",
        schoolCode: "School Code",
        month: "Month",
        year: "Year",
        contactPerson:
            "School's Contact Person (for enquiry by the EDB during processing this form)",
        telNo: "Tel No.",
        ssdo: "SSDO",
        pleaseSpecify: "please specify",
        partAOption: {
            tips1: "Our school has extended the paid maternity leave of the serving contract staff to 14-week",
            tips2: " and hereby applies for reimbursement of additional salary expenditure",
            tips3: " arising from the employment of eligible supply staff. Details are as follows:",
            title: "<b>Part A. Particulars of the serving contract staff and supply staff</b>",
            titleTips:
                " (please separately provide details of monthly-paid and daily-rated supply staff in Table I and Table II below)",
            title1: "I. Monthly-paid supply staff",
            monthTips:
                "Particulars of <b>serving contract staff</b> taking 14-week paid maternity leave",
            name: "Name",
            teachingStaff: {
                Yes: "Teaching staff",
                No: "Non-teaching staff",
            },
            leavePeriod: "Leave period",
            firstTenWeekLabel: "First 10 weeks",
            additionalWeekLabel: "Additional 4 weeks ({{serial}})",
            additionalWeek:
                "Salary details of the additional 4-week maternity leave",
            additionalWeekTips:
                "[should only take into account salaries payable under the EDB's cash grants] ({{serial}})",
            monthlySalary: "Monthly salary",
            amountUnit: "($)",
            month: "Month",
            rank: "Rank",
            percentage: "Percentage of full-time job",
            fundingSource: "Funding source for salaries",
            fundingSourceFile:
                "Salary proof of the serving contract staff taking 14-week paid maternity leave",
            monthlyPaidTips:
                "Particulars of all <b>monthly-paid supply staff</b> substituting the serving contract staff taking additional 4-week paid maternity leave [i.e. dates stated in (a) of this form]",
            dailyRatedTips:
                "Particulars of all <b>daily-rated supply staff</b> substituting the serving contract staff taking additional 4-week paid maternity leave [i.e. dates stated in (g) of this form]",
            supplyStaffName: "Name of supply staff",
            substitutionPeriodTitle:
                "Substitution period <i>[should be within the dates stated in ({{serial}})]</i>",
            substitutionPeriod: "Substitution period",
            from: "From",
            to: "To",
            workingDays: "Number of calendar days working as supply staff",
            salaryAmount: "Salary amount",
            salaryAmountFile:
                "Salary receipts of all persons employed as supply staff (covering the first ten weeks and the additional four weeks)",
            mpfSubsidy: "MPF subsidy",
            mpfSubsidyFile:
                "Proof of contribution to MPF for all persons employed as supply staff (if applicable)",
            mpfSubsidyFileTips:
                "[please provide justifications and evidence if contribution to MPF is necessary for supply staff employed less than 60 calendar days]",
            grantAmount: "Amount of Grant (f) = (d) + (e)",
            grantAmountDaily: "Amount of Grant (l) = (j) + (k)",
            grantAmountMsg: "Amount of Grant",
            dayAmount: "[ Converted average daily wage",
            dayAmountR: "]",
            dailyRate: "Daily rate",
            actualWorkingDays: "Number of actual working days",
            totalDays: "Total number of days",
            totalAmount: "Total amount",
            title2: "II. Daily-rated supply staff",
        },
        partBOption: {
            title: "<b>Part B. Amount claimed and supplementary information</b>",
            stepNote1:
                "During the 14-week paid maternity leave taken by the serving contract staff, the",
            stepNoteChild: {
                note1: "has continuously employed supply staff for 14 weeks to take up the duties that would otherwise be performed by the serving contract staff.",
                note2: "has employed supply staff to take up the duties that would otherwise be performed by the serving contract staff, but <u>the period of substitution is less than 14 weeks</u> because(may select more than one reason):",
            },
            childNoteOption: {
                childNoteA1:
                    "the paid maternity leave of the serving contract staff partially overlapped with major school holidays (i.e. ",
                childNoteA2:
                    "no suitable person was available as supply staff during part of the leave period",
                childNoteA3:
                    "there was not enough time for the school to recruit supply staff",
                childNoteA4:
                    "the school needed to employ more than one person as supply staff during the maternity leave period but there was/were gap(s) between their employment",
                childNoteA5:
                    "the monthly-paid supply staff has taken no-pay leave during the employment period, and details are as follows:",
                childNoteA6: "Others",
            },
            childNoteEndA1:
                ") and the schools did not consider it necessary to employ supply staff during the overlapped period",
            stepNote2Start: "applies to the EDB for reimbursement of ",
            stepNote2End:
                "under the Additional Substitute Staff Grant [the sum of the amounts stated in column (f) and column (l) in principle] to cover <u>on an accountable basis</u> the salary expenditure of supply staff incurred by the additional four-week paid statutory maternity leave taken by the serving contract staff (i.e. up to 28 days). Copies of the following documents, as <u>endorsed with the signature of the school supervisor</u>, are attached for the purpose of verification:",
            childNoteBOption: {
                childNoteB1: "salary proof of the serving contract staff;",
                childNoteB2:
                    "salary receipts of all persons employed as supply staff (covering the first ten weeks and the additional four weeks); and",
                childNoteB3:
                    "proof of contribution to MPF for all persons employed as supply staff (if applicable) [please provide justifications and evidence if contribution to MPF is necessary for supply staff employed less than 60 calendar days].",
            },
            left: "(",
            right: ") ",
            detailMsg: "details",
            specifyMsg: "reason",
            leaveType: {
                ch: "Christmas Holiday",
                cnyh: "Chinese New Year Holiday",
                eh: "Easter Holiday",
                sv: "Summer Vacation",
            },
        },
        partCOption: {
            title: "Part C. Certification",
            noteTitle: "I hereby certify that:",
            surplusTeachers: "Surplus Teachers",
            teacherNumber: "Number of Surplus Teachers",
            claimDate: "Claim Date",
            certifyNote1:
                "has examined the relevant documentary proof (including a valid certificate issued by a registered medical practitioner, a registered midwife or a registered Chinese medicine practitioner confirming pregnancy, and a medical certificate specifying the expected or actual date of confinement (as appropriate)), and given its approval for the above contract staff remunerated under cash grants to take the extended 14-week paid maternity leave in accordance with the Employment Ordinance (Cap. 57) and pertinent requirements set out by the EDB;",
            certifyNote2:
                "The supply staff have been requested to go through a sexual conviction record check and the checking results have been obtained via the auto-telephone answering system;",
            certifyNote3:
                "Supply staff employed as teachers must be registered teachers, or have obtained the qualifications that application for the status as registered teacher or permitted teacher requires and submitted an application for teacher registration prior to their assumption of duty. The school has carefully examined the original copies of the teachers' identity documents and certificate for registration as a teacher and/or checked the status of their teacher registration and other relevant information. Supply staff employed as non-teaching specialist staff have obtained the qualifications as required;",
            certifyNote4: "Our school ",
            certifyNote4Start:
                "surplus regular teacher(s) and the number of surplus regular teacher(s) <u>has already been offset</u> [i.e. At the same time, the number of teachers on leave for three or more consecutive days (which includes the regular teachers and contract teachers paid out of EDB cash grants) exceeds the number of surplus regular teachers. Please specify the details if necessary:",
            certifyNote4Char: "]",
            certifyNote4End:
                "during the period when supply teachers were employed to substitute the serving contract teachers taking the additional four weeks of paid statutory maternity leave. The salary expenditure of supply teacher(s) incurred by the additional four-week paid leave will not be reimbursed if the number of surplus regular teacher(s) has not been offset;",
            certifyNote5:
                "The information provided above is correct and complete (including employment information on <span style='border-bottom: 3px double #000;'>all</span> the supply staff who substitute the serving contract staff taking the additional four-week maternity leave). Our school has completed all procedures pertaining to this application, and understands that this application will not be processed by the EDB if any given information or documentary proof is found incomplete;",
            certifyNote6:
                "The school has made advance payment for the remuneration payable to the supply staff and other related expenses as required by statutory obligations;",
            certifyNote7:
                "Any excess of disbursed grant more than our school's entitlement will be returned to the Government; and",
            certifyNote8:
                "The additional four weeks' statutory maternity leave pay paid to the serving contract staff and the Additional Substitute Staff Grant have not been / will not be covered / subsidised by other government funding.",
            applicationDate: "Date of Application",
            supervisorName: "Name of Supervisor",
        },
        slash: "/",
        smcImc: "School Management Committee/Incorporated Management Committee",
    },
    select: {
        monthOption: [
            { key: "", value: "Please Choose" },
            { key: "01", value: "01" },
            { key: "02", value: "02" },
            { key: "03", value: "03" },
            { key: "04", value: "04" },
            { key: "05", value: "05" },
            { key: "06", value: "06" },
            { key: "07", value: "07" },
            { key: "08", value: "08" },
            { key: "09", value: "09" },
            { key: "10", value: "10" },
            { key: "11", value: "11" },
            { key: "12", value: "12" },
        ],
        ssdoOption: {
            CWD: "Central & Western District",
            SD: "Southern District",
            WCD: "Wan Chai District",
            ID: "Islands District",
            HKED: "Hong Kong East District",
            KCD: "Kowloon City District",
            SSPD: "Sham Shui Po District",
            SKD: "Sai Kung District",
            KTD: "Kwun Tong District",
            WTSD: "Wong Tai Sin District",
            YTMKD: "Yau Tsim & Mong Kok District",
            TPD: "Tai Po District",
            ND: "North District",
            STD: "Sha Tin District",
            KCTYD: "Kwai Chung & Tsing Yi District",
            TWD: "Tsuen Wan District",
            TMD: "Tuen Mun District",
            YLD: "Yuen Long District ",
        },
        supplyStaffOption: {
            PartAI: "I. Monthly-paid supply staff",
            PartAII: "II. Daily-rated supply staff",
        },
        schoolIncorporatedOption: {
            smc: "School Management Committee",
            imc: "Incorporated Management Committee",
        },
        surplusTeachersOption: {
            Yes: "has",
            No: "has no",
        },
    },
    errorMsg: {
        required: "This field is required",
        twoRequired: "The first two items are required",
        maxOneDecimal: "This field must be at most 1 decimal places",
        numberUnit: "This field smallest unit must be 0.5",
        validPrice: "Please input a valid price",
        numberMax: "This field must be at most {{number}} digits",
        telMax: "Telephone number must be at most 12 digits",
        monthDiffError: "Please choose a different month",
        monthRangeError:
            "Please select a month within the range of leave period (additional four-week)",
        substitutionPeriodError:
            "This item must be within the date range stated in field ({{fild}})",
        monthlySalaryError:
            "This field must be not exceed the monthly salary stated in field (b)",
        percentageError:
            "This field must be not exceed the percentage of full-time job stated in field ({{fild}})",
        dailyRateError:
            "This field must be not exceed the converted average daily wage in field (h)",
    },
};
export default Form078EN;
